import { BaseService } from "@/api/services/baseService";
import request from "@/api";

/**
 * 订单备注表单
 */
export interface OrderRemarkForm {
    orderId: number;
    fileId: number;
    remark?: string;
}

export class OrderRemarkService extends BaseService<unknown, unknown, unknown, unknown> {
    // 新增订单备注
    public async addOrderRemark(form: OrderRemarkForm) {
        return await this.service.post(`${this.path}`, form);
    }

    // 修改订单备注
    public async updateOrderRemark(id: number, form: OrderRemarkForm) {
        return await this.service.put(`${this.path}/${id}`, form);
    }

    // 删除订单备注
    public async deleteOrderRemark(id: number) {
        return await this.service.delete(`${this.path}/${id}`);
    }
}

export const orderRemarkService = new OrderRemarkService("/admin/order-remark", request.service);
